import extend from 'lodash/extend';

let registerData = {};
class Register {
  static setData(data) {
    extend(registerData, data);
  }

  static getData() {
    return registerData;
  }

  static clear() {
    registerData = {};
  }
}
export default Register;
